module.exports = __webpack_public_path__ + "img/1.4d3a4d82.png";